import { Component } from '@angular/core';
import { NavigationEnd, Router, Event, ActivationStart, ActivatedRoute } from '@angular/router';
import { TemplateReferenceService } from 'projects/lib_util/src/public-api';
import { AnalyticsService } from './services/analytics.service';
import { ApplicationSettings } from 'projects/lib_config/src/public-api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private templateReferenceService: TemplateReferenceService,
    private analyticsService: AnalyticsService,
    private appSettings: ApplicationSettings) {

    if (this.appSettings.enableAnalytics) {
      this.analyticsService.initAdobeLaunchDataLayer();
      this.analyticsService.injectAdobeLaunchScript();

      this.router.events.subscribe((event: Event) => {
        if (event instanceof ActivationStart) {
          if (event.snapshot.data.title && event.snapshot.data.section && event.snapshot.component) {
            this.analyticsService.trackPage(event.snapshot.data['section'], event.snapshot.data['title']);
          }
        }
      });
    }
  }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.templateReferenceService.reset();
      }
    });
  }
}
